import { render, staticRenderFns } from "./popover.vue?vue&type=template&id=e49edfbc"
import script from "./popover.vue?vue&type=script&lang=js"
export * from "./popover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\baby_doctor_platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e49edfbc')) {
      api.createRecord('e49edfbc', component.options)
    } else {
      api.reload('e49edfbc', component.options)
    }
    module.hot.accept("./popover.vue?vue&type=template&id=e49edfbc", function () {
      api.rerender('e49edfbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/QuickAdminTable/popover.vue"
export default component.exports